<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

const year = new Date().getFullYear()
</script>

<template>
  <Box is="footer" class="auth-footer">
    <Text type="caption" color="muted" class="auth-footer__copy">© {{ year }} Sliceal</Text>
    <Box class="auth-footer__links">
      <Text is="a" type="caption" color="muted" href="#" class="auth-footer__link">Terms</Text>
      <Text is="span" type="caption" color="muted" class="auth-footer__sep">•</Text>
      <Text is="a" type="caption" color="muted" href="#" class="auth-footer__link">Privacy</Text>
      <Text is="span" type="caption" color="muted" class="auth-footer__sep">•</Text>
      <Text is="a" type="caption" color="muted" href="#" class="auth-footer__link">Regulatory</Text>
    </Box>
  </Box>
</template>

<style scoped>
.auth-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  border-top: 1px solid var(--p-content-border-color);
  flex-shrink: 0;
  opacity: 0.85;
}

.auth-footer__copy,
.auth-footer__link,
.auth-footer__sep {
  font-size: 11px !important;
}

.auth-footer__links {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.auth-footer__link {
  text-decoration: none;
  transition: color 0.15s;
}

.auth-footer__link:hover {
  color: var(--p-primary-600);
}

.auth-footer__sep {
  opacity: 0.4;
}

@media (max-width: 992px) {
  .auth-footer {
    flex-direction: column-reverse;
    gap: 0.5rem;
    padding: 1rem;
  }
}
</style>
